import { INewWalletResponse } from '@entities/wallets';
import { useModal } from '@shared/components/Modal';

import { NewWalletMID } from './NewWalletMID';

export const useWalletCreate = (refetch: () => void) => {
  const { openModal } = useModal();

  const handleCreateWallet = (formData: FormData): FormData => {
    if (!formData.get('kind')) formData.delete('kind');
    return formData;
  };

  const handleSuccess = (response: INewWalletResponse) => {
    openModal(
      <NewWalletMID
        parent_id={response.data.id}
        parent_name={response.data.name}
        refetch={refetch}
        shouldSubmitDefaultSettings={true}
      />,
    );
  };

  return { handleCreateWallet, handleSuccess };
};
